<template>
  <div class="relative w-full" ref="wrapper">
    <!-- Icon / Flag -->
    <div
      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
    >
      <template v-if="selectedCountry?.code">
        <div class="flex items-center gap-2">
          <img
            class="w-[20px] h-[15px] object-cover"
            :src="`https://flagcdn.com/w20/${selectedCountry.code.toLowerCase()}.png`"
            alt="flag"
          />
          <div class="w-[1px] h-[15px] bg-black"></div>
        </div>
      </template>

      <template v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-400"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
                 10-4.48 10-10S17.52 2 12 2zm7.93 9h-3.02
                 c-.15-2.65-1-5.01-2.33-6.71A8.03 8.03 0 0119.93 11zm-5.02 0H9.09
                 c.14-2.36.89-4.5 2.05-6.06 1.16 1.56 1.91 3.7 2.05 6.06zM4.07 13h3.02
                 c.15 2.65 1 5.01 2.33 6.71A8.03 8.03 0 014.07 13zm5.02 0h3.82
                 c-.14 2.36-.89 4.5-2.05 6.06C9.98 17.5 9.23 15.36 9.09 13zm7.84 0h3.02
                 a8.03 8.03 0 01-5.35 6.71c1.33-1.7 2.18-4.06 2.33-6.71z"
          />
        </svg>
      </template>
    </div>

    <!-- Input -->
    <input
      v-model="search"
      @input="filterCountries"
      @focus="open = true"
      placeholder="Select your residency country"
      :class="[
        'w-full pr-4 py-1.5 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500',
        selectedCountry ? 'pl-12' : 'pl-10',
      ]"
    />

    <!-- Dropdown -->
    <ul
      v-if="open && filtered.length"
      class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded shadow max-h-60 overflow-auto"
    >
      <li
        v-for="option in filtered"
        :key="option.code"
        @click="selectCountry(option)"
        class="flex items-center px-3 py-2 hover:bg-gray-100 cursor-pointer"
      >
        <img
          :src="`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`"
          class="w-[20px] h-[15px] object-cover mr-2"
        />
        <span>{{ option.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { country } from "@/data/country";

export default {
  name: "CountryAutocomplete",

  props: {
    modelValue: String,
  },

  emits: ["update:modelValue", "select"],

  data() {
    return {
      search: "",
      open: false,
      selectedCountry: null,
      options: country,
      filtered: country,
    };
  },

  methods: {
    filterCountries() {
      this.search = this.search.trimStart();

      this.filtered = this.options.filter((opt) =>
        opt.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    selectCountry(option) {
      this.selectedCountry = option;
      this.search = option.name;
      this.open = false;

      this.$emit("update:modelValue", option.name);
      this.$emit("select", option);
    },

    // Click-outside logic (SAFE)
    handleClickOutside(e) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
        this.open = false;
      }
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
